import { Period } from '../api/generated/data-contracts';

const today = new Date();
export const getPeriodWithDate = (periods: Period[], date = today) => {
    const now = date.getTime();
    return periods.find(period => now <= new Date(period.endDate).getTime() && now >= new Date(period.startDate).getTime());
};
